<template>
    <sections>
        <section-jumbo
            heading="Cloud Video Solutions"
            headingColor="text-white"
            content="<article-home-hero />"
            contentColor="text-gray-200"
            :image="jumbo.image"
            :imageSizes="jumbo.imageSizes"
            :imageSet="jumbo.imageSet"
            imagePosition="object-bottom"
            imageOpacity="opacity-80"
        ></section-jumbo>
        <section-image
            heading="Video Architecture"
            headingComponent="h2"
            content="<article-home-image />"
            :image="image.image"
            :imageSizes="image.imageSizes"
            :imageSet="image.imageSet"
        ></section-image>
        <section-text
            color="bg-zinc-50"
            heading="We'd love to hear from you!"
            content="<p>Drop us a message and we'll be in touch.</p>"
            buttonRoute="/contact"
            buttonText="Contact Us"
            :textCentered="true"
        ></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const jumbo = {
    imageSizes: '100vw',
    imageSet: `
        ${$config.public.images}home-jumbo-200.webp 200w,
        ${$config.public.images}home-jumbo-708.webp 708w,
        ${$config.public.images}home-jumbo-917.webp 917w,
        ${$config.public.images}home-jumbo-1086.webp 1086w,
        ${$config.public.images}home-jumbo-1302.webp 1302w,
        ${$config.public.images}home-jumbo-1383.webp 1383w,
        ${$config.public.images}home-jumbo-1400.webp 1400w
    `,
    image: `${$config.public.images}home-jumbo.jpg`,
};

const image = {
    imageSizes: '(max-width: 696px) 100vw, 696px',
    imageSet: `
        ${$config.public.images}home-image-200.webp 200w,
        ${$config.public.images}home-image-468.webp 468w,
        ${$config.public.images}home-image-684.webp 684w,
        ${$config.public.images}home-image-696.webp 696w
    `,
    image: `${$config.public.images}home-image.jpg`,
};

useSeo().buildHead({
    title: `${$config.public.siteName} | Cloud Video Solutions`,
    description: $config.public.siteStrapline,
    index: true,
});
</script>
